const state =  {
	/*user: {
		permissions: []
	},
	authenticating: false,
	rules: [],
	token: TokenService.getToken(),
	authenticationErrorCode: 0,
	authenticationError: ''*/
};

const getters = {
	/*loggedIn: (state) => {
		return !!state.token
	},

	authenticationErrorCode: (state) => {
		return state.authenticationErrorCode
	},

	authenticationError: (state) => {
		return state.authenticationError
	},

	authenticating: (state) => {
		return state.authenticating
	},

	userPermissions: (state) => {
		return state.user.permissions
	}*/
}

const actions = {
	/*async login({ commit }, userData) {
		commit('loginRequest');

		try {
			const user = await UserService.login(userData);
			commit('loginSuccess', user);

			// Redirect the user to the page he first tried to visit or to the home view
			let routeHistory = router.history.current.query.redirect;
			router.push(routeHistory && routeHistory != '/login' ? routeHistory : '/');

			return true
		} catch (e) {
			commit('loginError', {errorCode: e.errorCode, errorMessage: e.message})
			return false
		}
	},

	logout({ commit }) {
		UserService.logout();
		commit('logoutSuccess');
		router.push('/login')
	}*/
}

const mutations = {
	/*loginRequest(state) {
		state.authenticating = true;
		state.authenticationError = '';
		state.authenticationErrorCode = 0
	},

	loginSuccess(state, user) {
		state.user = user;
		state.rules = user.permissions;
		state.token = user.token;
		state.authenticating = false;
	},

	loginError(state, {errorCode, errorMessage}) {
		state.authenticating = false
		state.authenticationErrorCode = errorCode
		state.authenticationError = errorMessage
	},

	logoutSuccess(state) {
		state.token = '';
		state.rules = []
	}*/
}

export const auth = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
